import React, { useState } from 'react';
import { generatePdf } from '../api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

interface Props {
  item: any;
  onClose: () => void;
}

export default function CurriculoModal({ item, onClose }: Props) {
  const d = item.data || {};
  const [loading, setLoading] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');
  const [deleteError, setDeleteError] = useState('');
  const navigate = useNavigate();

  const handleGeneratePDF = async () => {
    setLoading(true);
    try {
      const blob = await generatePdf(item.cpf, d);
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `curriculo_${item.cpf}.pdf`;
      a.click();
    } catch (e) {
      alert('Erro ao gerar PDF');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    sessionStorage.setItem('cpf', item.cpf);
    sessionStorage.setItem('curriculoData', JSON.stringify(item.data));
    sessionStorage.removeItem('anon');
    onClose();
    navigate('/curriculo');
  };

  const handleDelete = async () => {
    setDeleteError('');
    setLoading(true);
    try {
      const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
      await axios.delete(
        (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '') + `/curriculo/${item.cpf}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          data: { deletePassword }
        }
      );
      alert('Currículo excluído com sucesso!');
      setDeleteMode(false);
      onClose();
    } catch (e: any) {
      setDeleteError(e?.response?.data?.error || 'Erro ao excluir currículo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
    }}>
      <div style={{ width: '90%', maxWidth: 800, maxHeight: '90vh', overflowY: 'auto', background: '#fff', padding: 20, borderRadius: 8 }}>
        <h3>Resumo — {d?.dadosPessoais?.nome || 'Não informado'}</h3>
        <p><strong>CPF:</strong> {item.cpf}</p>
        <p><strong>Contato:</strong> {d?.dadosPessoais?.telefone || '—'} | {d?.dadosPessoais?.email || '—'}</p>
        <p>
          <strong>Infos Pessoais:</strong> {d?.dadosPessoais?.idade ? `${d.dadosPessoais.idade} anos` : '—'} 
          {d?.dadosPessoais?.estadoCivil ? `, ${d.dadosPessoais.estadoCivil}` : ''}
          {d?.dadosPessoais?.cidade ? ` | ${d.dadosPessoais.cidade} ${d?.dadosPessoais?.bairro ? '- ' + d.dadosPessoais.bairro : ''}` : ''}
        </p>

        <div style={{ marginTop: 12 }}>
          <h4>Objetivo</h4>
          <p>
            {d?.objetivo?.setor ? <strong>Setor: </strong> : ''}{d?.objetivo?.setor || ''} 
            {d?.objetivo?.modalidade ? <strong style={{ marginLeft: 8 }}>Modalidade: </strong> : ''}{d?.objetivo?.modalidade || ''}
          </p>
          <p style={{ marginTop: 4 }}>{d?.objetivo?.observacoes || '—'}</p>
        </div>

        <div style={{ marginTop: 12 }}>
          <h4>Formação</h4>
          {d?.formacao?.filter((f: any) => f && f.formacao).length ? (
            <ul>
              {d.formacao.filter((f: any) => f && f.formacao).map((f: any, i: number) => <li key={i}>{f.formacao} — {f.instituicao} ({f.anoFinalizacao || '—'})</li>)}
            </ul>
          ) : <p>—</p>}
        </div>

        <div style={{ marginTop: 12 }}>
          <h4>Experiência</h4>
          {d?.experiencias?.filter((e: any) => e && e.empresa).length ? (
            <ul>
              {d.experiencias.filter((e: any) => e && e.empresa).map((e: any, i: number) => <li key={i}>{e.empresa} — {e.cargo} ({e.dataInicio || '—'} a {e.dataFim || '—'})</li>)}
            </ul>
          ) : <p>—</p>}
        </div>

        <div style={{ marginTop: 12 }}>
          <h4>Cursos Complementares</h4>
          {d?.cursosComplementares?.filter((c: any) => c && c.curso).length ? (
            <ul>
              {d.cursosComplementares.filter((c: any) => c && c.curso).map((c: any, i: number) => <li key={i}>{c.curso} — {c.instituicao} ({c.ano || '—'})</li>)}
            </ul>
          ) : <p>—</p>}
        </div>

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button className="btn" onClick={handleGeneratePDF} disabled={loading}>
            {loading ? 'Gerando PDF...' : 'Gerar PDF'}
          </button>
          <button className="btn btn-primary" onClick={handleEdit}>
            Editar currículo
          </button>
          <button className="btn btn-danger" onClick={() => setDeleteMode(v => !v)}>
            Excluir currículo
          </button>
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
        </div>

        {deleteMode && (
          <div style={{ marginTop: 18, background: '#fff0f0', padding: 16, borderRadius: 8 }}>
            <div>
              <strong>Digite a senha de exclusão para remover este currículo:</strong>
            </div>
            <input
              type="password"
              value={deletePassword}
              onChange={e => setDeletePassword(e.target.value)}
              style={{ marginTop: 8, marginBottom: 8, width: 220 }}
            />
            <button className="btn btn-danger" onClick={handleDelete} disabled={loading || !deletePassword}>
              Confirmar exclusão
            </button>
            <button className="btn btn-secondary" onClick={() => setDeleteMode(false)} style={{ marginLeft: 8 }}>
              Cancelar
            </button>
            {deleteError && <div style={{ color: 'red', marginTop: 8 }}>{deleteError}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
